import CardWrapper from '../card-wrapper';
import Step02Image from '../../../../../assets/images/memory/onboarding/step-02.svg';
import { Typography } from '../../../../../core/components/molecules/Typography';
import StepButton from '../step-button';
import { Icon } from '../../../../../core/components/atoms/Icon';

const Step02 = ({
  onNextStep,
  onPreviousStep,
}: {
  onNextStep: () => void;
  onPreviousStep: () => void;
}) => {
  return (
    <CardWrapper.Root side='left' className='my-10'>
      <CardWrapper.Primary className='flex flex-col items-center justify-center gap-4 px-5'>
        <div className='flex flex-col items-start gap-4'>
          <Typography
            title='h1'
            className='!text-h1 font-bold text-mono-color-darker'
          >
            Decks: onde tudo começa
          </Typography>
          <Typography
            title='h3'
            className='!text-h3 font-bold text-mono-color-darker'
          >
            Criando um Deck
          </Typography>
          <Typography
            title='h1'
            className='!text-md !font-normal text-mono-color-darker'
          >
            Na área de Decks, clique em Criar Decks. Em seguida, adicione o nome
            que queira dar para o Deck. O Deck será onde você irá adicionar os{' '}
            <i>flashcards</i> para suas Revisões.
          </Typography>
        </div>
        <div className='flex w-full justify-end'>
          <StepButton label='Voltar' onClick={onPreviousStep} type='text' />
          <StepButton
            label='Continuar'
            onClick={onNextStep}
            icon={<Icon Icon={'keyboard_arrow_right'} type='material' />}
          />
        </div>
      </CardWrapper.Primary>

      <CardWrapper.Secondary className='h-[438px] w-full md:w-[554px]'>
        <img
          src={Step02Image}
          alt='Step 02'
          className='h-full w-full rounded-lg md:object-cover'
        />
      </CardWrapper.Secondary>
    </CardWrapper.Root>
  );
};

export default Step02;
